import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileHeaderComponent } from './mobile-header.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [MobileHeaderComponent],
  imports: [CommonModule, RouterModule, SharedModule],
  exports: [MobileHeaderComponent],
})
export class MobileHeaderModule {}
